export const px = (value: string) => Number.parseFloat(value) || 0

export const tabsEnd = (list: HTMLElement) => {
  const tabs = list.querySelectorAll<HTMLElement>('[role="tab"]')
  const last = tabs[tabs.length - 1]
  if (!last) {
    return list.scrollWidth
  }
  return last.offsetLeft + last.offsetWidth + px(getComputedStyle(list).paddingInlineEnd)
}
